export default {"src":"/_next/static/media/HotjobsLogo.816d4a31.svg","height":38,"width":154,"blurWidth":0,"blurHeight":0};